import React, { useEffect } from 'react';
import { useMount } from 'react-use';
import { Helmet } from 'react-helmet';
import ym from 'react-yandex-metrika';
import qs from 'query-string';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router';

import { TeacherReservePage as ModulesTeacherReservePage } from '@edu-frontend/modules/src/pages/teacherReservePage';
import { useIntl, useStaticUrls, useGeneratePath } from 'platform-components';

import { TeacherHeader } from 'common.components/TeacherHeader/TeacherHeader';
import { useTeacherReserveParams } from 'common.components/widgets.teacher-reserve';
import { scrollTo } from 'utils/scroll-to';
import { getTeacherCoursesByClassRequest } from 'store/teacher-courses/actions';
import { getClassesIdToLoad, getCurrentOrFirstTeamIdWithSubject } from 'store/teacher-courses/selectors';

export const TeacherReservePageActive = () => {
    const dispatch = useDispatch();
    const intl = useIntl();
    const { search } = useLocation();
    const { anchor } = qs.parse(search);

    const { labClassTeacherReserve } = useStaticUrls();
    const history = useHistory();
    const generatePath = useGeneratePath();

    const teamsIdsToLoad = useSelector(getClassesIdToLoad);
    const teamIdWithInformatics = useSelector((store) =>
        getCurrentOrFirstTeamIdWithSubject(store, { subject: 'informatics' })
    );

    useMount(() => {
        ym('reachGoal', 'teacher_talent_pool_view');
        // если отсутствует якорь, скроллим в начало
        if (!anchor) {
            scrollTo(0, 0);
        }

        if (!teamIdWithInformatics) {
            dispatch(getTeacherCoursesByClassRequest(teamsIdsToLoad));
        }
    });

    // Добавляем в урл classId, потому что он нужен для переходов по активностям
    useEffect(() => {
        if (teamIdWithInformatics) {
            history.replace(generatePath(`${labClassTeacherReserve}${search}`, { classId: teamIdWithInformatics }));
        }
        // лишние зависимости вызывают бесконечный перерендер
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [teamIdWithInformatics]);

    const params = useTeacherReserveParams();

    return (
        <>
            <Helmet title={intl.formatMessage({ id: 'teacherReserve.pageTitle' })} />
            <TeacherHeader hideRightControls />

            {params.error ? null : <ModulesTeacherReservePage className="teacher-reserve-page" {...params} />}
        </>
    );
};
